import { company } from "./company";
import { complaints } from "./complaints";
import { dashboard } from "./dashboard";
import { auth } from "./login";
import { media } from "./media";
import { permissions } from "./permissions";
import { property } from "./property";
import { resident } from "./resident";
import { role } from "./role";
import { settings } from "./settings";
import { user } from "./user";
import { violation } from "./violations";

export const services ={
    auth,
    user,
    role,
    property,
    company,
    violation,
    resident,
    media,
    complaints,
    settings,
    permissions,
    dashboard

}